const certificates = {
  title: "Certificates",
  items: [
    {
      name: "Introduction to IoT",
      organization: "NPTEL"
    },
    {
      name: "Deep Learning",
      organization: "NPTEL"
    },
    {
      name: "Big Data Computing",
      organization: "NPTEL"
    },
    {
      name: "Microsoft Certified: AI Fundamentals",
      organization: "Microsoft"
    }
  ]
}

export default certificates;